import Vue from 'vue'
import Vuex from 'vuex'
import activity from './modules/activity'
import shop from './modules/shop'
import activityCategory from './modules/activityCategory'
import menberCharge from './modules/menberCharge'
import menber from './modules/menber'
import live from './modules/live'
import activiSession from './modules/activiSession'
import shopRoles from './modules/shopRoles'
import platRoles from './modules/platRoles'
import order from './modules/order'
import popup from './modules/popup'
import theme from './modules/theme'
import roles from './modules/roles'
import inviteCode from './modules/inviteCode'
import articles from './modules/articles'
import ticket from './modules/ticket'
import gift from './modules/gift'
import fullAmounCoupon from './modules/fullAmounCoupon'
import activityStatus from './modules/activityStatus'
import comments from './modules/comments'
import actionLogs from './modules/actionLogs'
import language from './modules/language'
import blackList from './modules/blackList'
import recharge from './modules/recharge'
import rechargeRecord from './modules/rechargeRecord'
import music from './modules/music'
import memberShip from './modules/memberShip'
import banners from './modules/banners'
import splashes from './modules/splashes'
import versions from './modules/versions'
import push from './modules/push'
import giftReward from './modules/giftReward'
import giftCategory from './modules/giftCategory'
import liveCategory from './modules/liveCategory'
import coupons from './modules/coupons'
import userCoupons from './modules/userCoupons'
import registerCoupon from './modules/registerCoupon'
import coinList from './modules/coinList'
import pointList from './modules/pointList'
import prize from './modules/prize'
import game from './modules/game'
import regions from './modules/regions'
import webLoading from './modules/webLoading'
import googleMaps from './modules/googleMap'
import points from './modules/points'
import merchantCoupon from './modules/merchantCoupon'
import userGoods from './modules/userGoods'
import common from './modules/common';
import compartment from './modules/compartment';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        activity,
        shop,
        activityCategory,
        menberCharge,
        menber,
        live,
        activiSession,
        shopRoles,
        platRoles,
        order,
        popup,
        theme,
        roles,
        inviteCode,
        articles,
        ticket,
        gift,
        fullAmounCoupon,
        activityStatus,
        comments,
        actionLogs,
        language,
        blackList,
        recharge,
        rechargeRecord,
        music,
        memberShip,
        banners,
        splashes,
        versions,
        push,
        giftReward,
        giftCategory,
        liveCategory, 
        coupons,
        userCoupons, 
        registerCoupon,
        coinList,
        pointList,
        prize,
        game,
        regions,
        webLoading,
        googleMaps,
        points,
        merchantCoupon,
        userGoods,
        common,
        compartment
    }
})
